/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import {useSelector} from 'react-redux'
import {AppRootState} from '../model/config'
import {App} from '../model/apps'

const filterAccessibleApps = (app: App) => app.hasAccess

const useRegisteredApps = (fetchAll?: boolean): [App[]] => {
  const appPredicate = fetchAll ? () => true : filterAccessibleApps

  const registeredApps = useSelector(
    (state: AppRootState) => state.app.registeredApps
  ).filter(appPredicate)

  return [registeredApps]
}

export default useRegisteredApps
